import Konva from 'konva/konva'
import YScaleLabel from './y-scale-label'
import { linearTransform } from '../utils'

const minDistance = 35
const inMagnitudeThresholds = [1, 2, 5]
const exponents = [-3, -2, -1, 0, 1, 2, 3, 4, 5]
const thresholdsExponents = exponents
  .map(exponent => inMagnitudeThresholds.map(threshold => [exponent, Math.pow(10, exponent) * threshold]))
  .reduce((acc, tuples) => acc.concat(tuples)) // flat

export default class AnalogueVariableScale extends Konva.Group {
  constructor ({ width, yFrom, yTo, minValue, maxValue }) {
    super({ width })
    Object.assign(this, { yFrom, yTo, minValue, maxValue })

    this._render()
  }

  _renderLabel (y, text) {
    const scaleWidth = this.width()
    this.add(new YScaleLabel({ scaleWidth, y, text }))
  }

  _render () {
    const { yFrom, yTo, minValue, maxValue } = this
    if (minValue !== null && maxValue !== null) { // accept 0 values!
      this._renderLabel(yFrom, maxValue)
      this._renderLabel(yTo, minValue)

      this._generateIntermediateTicks()
    }
  }

  _generateIntermediateTicks () {
    const exponentTickStep = this._determineTickStep()
    if (exponentTickStep) {
      const tickData = this._generateTickData(exponentTickStep)
      this._renderTicks(tickData)
    }
  }

  _determineTickStep () {
    const { yFrom, yTo, minValue, maxValue } = this
    const count = Math.floor((yTo - yFrom) / minDistance - 1)
    const diff = maxValue - minValue
    if (count > 0) {
      return thresholdsExponents.find(([_, threshold]) => diff / count < threshold)
    }
  }

  _generateTickData ([exponent, tickStep]) {
    const { yFrom, yTo, minValue, maxValue } = this
    const tickValues = []
    let value = Math.ceil(minValue / tickStep) * tickStep
    while (value < maxValue) {
      const y = linearTransform({ from: minValue, to: maxValue }, { from: yTo, to: yFrom }, value)
      if (y - yFrom > minDistance && yTo - y > minDistance) {
        tickValues.push({ value, y })
      }
      value += tickStep
      if (tickStep < 1) { // when decimal numbers, round properly to remove JS floating point artifacts
        const rounding = Math.pow(10, -exponent)
        value = Math.round(value * rounding) / rounding
      }
    }
    return tickValues
  }

  _renderTicks (tickData) {
    tickData.forEach(({ value, y }) => {
      this._renderLabel(y, value)
    })
  }
}
